import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui/tabs'
import { useState } from 'react'
import SettingsIpfsPage from './ipfs'

const BrowserSettingsPage = () => {
	const [currentTab, setCurrentTab] = useState<string>('ipfs')
	return (
		<div>
			<Tabs defaultValue='blog' className='w-full' value={currentTab} onValueChange={setCurrentTab}>
				<TabsList className='grid w-full grid-cols-2'>
					<TabsTrigger value='ipfs'>IPFS</TabsTrigger>
					<TabsTrigger value='sponsors' disabled>
						Crypto
					</TabsTrigger>
				</TabsList>
				<TabsContent value='ipfs' className='rounded-lg border-[1px] p-4'>
					<SettingsIpfsPage />
				</TabsContent>
			</Tabs>
		</div>
	)
}

export default BrowserSettingsPage
